import { readableColor } from 'polished';
import { css } from 'styled-components';

// The library's CalendarDate paints the selected ("active") day background and the today
// ("current") text with the fixed `palette.systemBlue` token, which ignores the building brand.
// Both now read one colour source: `theme.colors.primary`, the building primary colour
// (see useGetTheme).
const brandDayColor = css`
  ${({ theme }) => theme.colors.primary}
`;

// Text on the selected day follows the brand's lightness: a light brand colour gets dark text instead
// of white-on-light. Same pairing as `--primary-foreground` in useBrandCssVariables. `readableColor`
// throws on a colour it can't parse, so white (the library's own pairing) stays the fallback.
export const getSelectedDayTextColor = (background: string, white: string): string => {
  try {
    return readableColor(background, '#000000', white);
  } catch {
    return white;
  }
};

export const brandedDayCellStyles = css`
  .day-cell-active {
    color: ${({ theme }) => getSelectedDayTextColor(theme.colors.primary, theme.colors.universal.white)};
    background-color: ${brandDayColor};
  }

  // Not when the today cell is also the selected one: the active rule above must keep its readable text,
  // or today's number would vanish into a brand-coloured background (equal specificity, later wins).
  .day-cell-current:not(.day-cell-active) {
    color: ${brandDayColor};
  }
`;
